import { render, staticRenderFns } from "./StockSource.vue?vue&type=template&id=56188c2a&"
import script from "./StockSource.vue?vue&type=script&lang=js&"
export * from "./StockSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports